import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.indexOf('/api') !== 0) {
      return next.handle(req);
    }

    let request = req;

    const token = localStorage.getItem('token');
    if (token) {
      request = req.clone({
        headers: req.headers.set('x-access-token', token)
      });
    }

    if (req.url.indexOf('/api/auth/login') !== 0
      && req.url.indexOf('/api/auth/token_refresh') !== 0
      && this.authService.isRefreshTokenRequired()) {
      this.authService.refreshToken();
    }

    return next.handle(request).catch(
      (err: HttpErrorResponse) => {
        if (err.status === 401
          && this.router.url.indexOf('/login') !== 0
          && this.router.url.indexOf('/admin/login') !== 0
        ) {
          this.router.navigate(['/logout'], { queryParams: { returnUrl: this.router.url } });
        }
        return Observable.throw(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/inteceptors/auth-interceptor.ts